// extracted by mini-css-extract-plugin
module.exports = {"infoItems":"district-info_infoItems__2oVWL"};